import jsCookie from 'js-cookie'


class LocationClazz {
    getHostName(url) {
        var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
        if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
        return match[2];
        }
        else {
            return null;
        }
    }
    getDomain(url) {
        var hostName = this.getHostName(url);
        var domain = hostName;
        
        if (hostName != null) {
            var parts = hostName.split('.').reverse();
            
            if (parts != null && parts.length > 1) {
                domain = parts[1] + '.' + parts[0];
                    
                if (hostName.toLowerCase().indexOf('.co.uk') != -1 && parts.length > 2) {
                  domain = parts[2] + '.' + domain;
                }
            }
        }
        
        return domain;
    }
}

export const loc = new LocationClazz();

 const newJc = function(){

 }

 for (let [key, value] of Object.entries(jsCookie)) {
    if(key === 'set') {
        const newVal = (...args) =>{
            const domain = loc.getDomain(location.href);
            if(!args[2]) {
                args[2] = {domain}
            } else if(args[2] && !args[2].domain){
                args[2].domain = domain;
            };
            value(...args)
        }
        newJc[key] = newVal;
    } else if(key === 'remove'){
        const newVal = (...args) =>{
            const domain = loc.getDomain(location.href);
            if(!args[1]) {
                args[1] = {domain}
            } else if(args[1] && !args[1].domain){
                args[1].domain = domain;
            };
            value(...args)
        }
        newJc[key] = newVal;
    } else {
        newJc[key] = value;
    }
    
  }

  export const cookies = newJc
// export const cookies  = new Proxy(jsCookie,{
//     get(target, name) {
//         switch( name ) {
//             case 'set':
//                 return (...args) =>{
//                     const domain = loc.getDomain(location.href);
//                     if(!args[2]) {
//                         args[2] = {domain}
//                     } else if(args[2] && !args[2].domain){
//                         args[2].domain = domain;
//                     }
//                     Reflect.get(target, name).apply(this, args );
//                 }
//             break
//         }

//         return Reflect.get(target, name);  
//     }
// })